<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>
<div class="top-panel p-16">
  <div class="flex flex-row justify-between">
    <div class="flex flex-row mb-16">
      <app-default-filter [defaultFilterOptions]="defaultFilterOptions"
                          [selectedDefaultFilter]="selectedDefaultFilter" (changed)="defaultFilterChanged($event)"></app-default-filter>
    </div>
    <div class="flex flex-row justify-center items-center">
      <div class="flex justify-between items-center search-wrapper">
        <app-search-filter (keyup)="searchInstance($event)" [placeholder]="'INSTANCE_MGMT.SEARCH_INSTANCE'"></app-search-filter>
      </div>
      <button class="flex justify-center items-center context-menu-icon height menu-btn pl-6 pr-6" (click)="filterColumns()">
        <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
        <span class="fw-500 filters">{{'INSTANCE_LIST.FILTERS' | transloco}}</span>
      </button>
    </div>
  </div>

  <div class="flex flex-row flex-wrap items-center pt-10 pb-16">
    <div class="flex flex-row items-center" *ngIf="tenantId">
      <span class="fw-400">{{ 'TOOLBAR.TENANT' | transloco }}</span>
      <ng-container *ngIf="isMultipleTenant else individualTenant">
        <span *ngFor="let tenant of tenantId" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
          {{tenant | uppercase}}
          <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(tenant)"></mat-icon>
        </span>
      </ng-container>
      <ng-template #individualTenant>
        <span *ngIf="tenantId" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
          {{tenantId | uppercase}}
          <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(tenantId)"></mat-icon>
        </span>
      </ng-template>
    </div>
    <div class="flex flex-row items-center" *ngIf="status">
      <span class="fw-400">{{ 'TOOLBAR.STATUS' | transloco }}</span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{status | titlecase}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(status)"></mat-icon>
      </span>
    </div>
    <div class="flex flex-row items-center mr-16" *ngIf="managementType">
      <span class="fw-400">{{ 'TOOLBAR.TYPE' | transloco }}</span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{managementType === ManagementTypes.EXTERNAL? ('INSTANCE_LIST.EXTERNAL' | transloco) : ('INSTANCE_LIST.EXTERNAL_FOR_ACTION' | transloco)}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(managementType)"></mat-icon>
      </span>
    </div>
    <div class="flex flex-row items-center mr-16">
      <span *ngIf="tenantId || status" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetFilter()">
        {{ 'BUTTONS.CLEAR_ALL' | transloco }}
      </span>
    </div> 
  </div>


  <div class="flex flex-col border-radius">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.INSTANCE_NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let data" class="cursor-pointer" (click)="openInstanceDetails(data)">
          <div class="flex justify-start items-center">
            <span class="cell-data instance-name" [title]="data.name">{{data.name}}</span>
            <mat-icon *ngIf="data.name === 'Demo Instance'" svgIcon="info" class="icon-md-1 pl-8 icon"
              matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="tenantId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.TENANT' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data" class="cell-data" [title]="data.tenantId"> {{data.tenantId}} </td>
      </ng-container>

      <ng-container matColumnDef="dateCreated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.CREATED_DATE' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{dateTimeFormatService.getUtcFromat(data.dateCreated)}} </td>
      </ng-container>

      <ng-container matColumnDef="regionPair">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.REGION' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{data.region || data.regionPair}} </td>
      </ng-container>

      <ng-container matColumnDef="dataZone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.DATA_ZONE' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{data.dataZone}} </td>
      </ng-container>

      <ng-container matColumnDef="deploymentClass">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.DEPLOYMENT_CLASS' | transloco }} </th>
        <td mat-cell *matCellDef="let data" class="cell-width"> {{data.instanceClass}} </td>
      </ng-container>

      <ng-container matColumnDef="randomSuffix">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.RANDOM_SUFFIX' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data"> {{data.randomSuffix}} </td>
      </ng-container>

      <!-- <ng-container matColumnDef="instanceClass">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.INSTANCE_CLASS' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data" class="cell-width"> {{data.instanceClass}} </td>
      </ng-container> -->

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.STATUS' | transloco }} </th>
        <td mat-cell *matCellDef="let data">
          <span *ngIf="data.status !== DeployStatus.TERMINATING && data.status !== DeployStatus.DEPLOYING && data.status !== DeployStatus.CONFIGURING
            && data.status !== DeployStatus.UPDATING" class="status p-4" [ngClass]="data?.status">{{data.status | titlecase}}</span>
          <ng-container *ngIf="data.status === DeployStatus.TERMINATING || data.status === DeployStatus.DEPLOYING || data.status === DeployStatus.CONFIGURING
            || data.status === DeployStatus.UPDATING">
            <span>{{data.status | titlecase}}</span>
            <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
          </ng-container>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="endpoints">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_LIST.ENDPOINTS' | transloco }} </th>
        <td mat-cell *matCellDef="let data" class="cursor-pointer pl-36" [ngClass]="{'disable-endpoint': (data.status === DeployStatus.TERMINATING
          || data.status === DeployStatus.DEPLOYING || data.status === DeployStatus.TERMINATED)}"
          (click)="showEndpoints(data)">
          <mat-icon svgIcon="desktop_windows" class="icon-sm"></mat-icon>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="menu">
        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
        <td mat-cell *matCellDef="let data">
          <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8"
            [matMenuTriggerFor]="instanceSubmenu">
            <mat-icon svgIcon="more_vert"></mat-icon>
          </button>
          <mat-menu #instanceSubmenu [xPosition]="'before'" class="context-menu-dropdown">
            <button class="menu-button" (click)="addRemoveBookmark(data)">
              <div class="flex flex-row justify-start items-center" [ngClass]="{'remove': data.bookmarked}">
                <mat-icon [svgIcon]="data.bookmarked ? 'bookmark' : 'bookmark_border'" class="icon-md pt-2"
                  [ngClass]="{'remove': data.bookmarked}"></mat-icon>
                <div class="mat-body fw-400">{{ (data.bookmarked ? 'INSTANCE_LIST.REMOVE_BOOKMARK' : 'INSTANCE_LIST.BOOKMARK') | transloco }}</div>
              </div>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
      
    </mat-card>
    <div *ngIf="isFailed" class="flex items-center justify-center pt-48 pb-48">
      {{'INSTANCE_LIST.NO_INSTANCE_MESSAGE' | transloco }}
    </div>
    <div *ngIf="instanceData?.data?.length === 0 && !showSpinner" class="flex flex-col items-center justify-center pt-48 pb-48">
      <img src="/assets/images/instance-not-found-small.png" alt="No Data Found" class="mb-4" />
      <div class="fw-600 fs-16">
        {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
      </div>
    </div>
    <app-paginator *ngIf="dataSource?.data?.length > 0 && showPagination && !isFailed" class="p-24" [length]="totalRecords" [pageSizeOptions]="[10, 20]"
      [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
  </div>
</div>
